import { useRef } from 'react'

import PaperClipOutlinedIcon from '@ant-design/icons/PaperClipOutlined'

import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import { ACCEPT_ATTRIBUTE } from './TaskAttachments.utils'

export default function DropStrip({ onFiles, disabled = false, text = 'Drop or paste files here, or' }) {
  const inputRef = useRef(null)

  return (
    <Stack direction="row" sx={styles.strip}>
      <PaperClipOutlinedIcon />
      <Typography sx={{ color: 'inherit' }}>
        {text}{' '}
        <Link
          component="button"
          type="button"
          underline="always"
          disabled={disabled}
          onClick={() => inputRef.current?.click()}
          sx={{ verticalAlign: 'baseline' }}
        >
          browse
        </Link>
      </Typography>
      <FileInput inputRef={inputRef} onFiles={onFiles} />
    </Stack>
  )
}

export function FileInput({ inputRef, onFiles }) {
  return (
    <input
      ref={inputRef}
      type="file"
      hidden
      multiple
      accept={ACCEPT_ATTRIBUTE}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        onFiles(Array.from(e.target.files))
        e.target.value = ''
      }}
    />
  )
}

const styles = {
  strip: {
    gap: 1,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed',
    borderColor: 'divider',
    borderRadius: 1,
    color: 'text.secondary',
    backgroundColor: 'background.paper',
  },
}
